import React from 'react';

import { CheckboxGroup } from '@core/js/components/common/Fields/CheckboxGroup';

import { TTabsProps } from './types';

import style from './Tabs.scss';

const classNames = {
    control: style.controlWrap,
    list: style.list,
    item: style.item,
    checkbox: style.checkbox,
    error: style.errorWrap,
    content: style.groupContent
};

const classNamesTab = {
    checkbox: style.checkbox,
    content: style.content,
    control: style.control,
    checkMark: style.checkMark,
    label: style.label,
    error: style.error
};

export const Tabs: React.FC<TTabsProps> = ({ name, options = [], disabled = false, className = '' }) => {
    const tabsOptions = options.map(option => ({ type: 'radio', classNames: classNamesTab, ...option }));

    return (
        <CheckboxGroup
            name={name}
            disabled={disabled}
            options={tabsOptions}
            className={className}
            classNames={classNames}
        />
    );
};
